module.exports = __webpack_public_path__ + "static/media/sign_7.05e6afb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/style/sign_7.png
// module id = 336
// module chunks = 72